import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo=""
      portada=" "
      paginas={[
        " ",
        " ",
    
      ]}
      sugeridos={[]}


      info={{
        grupo: "Pierrot",
        tipo: "Manga",
        idioma: "Español",
        serie: "Naruto",
        personajes: [" "],
        etiquetas: [" "],
        artistas: "Masashi",
      }}
    />
  );
}

export const infoManga = {
  titulo: " ",
  portada: " ",
  reverso: " ",
   fecha:"2026-05-17",


  info: {
    grupo: "Pierrot",
    tipo: "Manga",
    idioma: "Español",
    serie: "Naruto",
    personajes: [" "],
    etiquetas: ["Acción", "Ninja", "Aventura"],
    artistas: " ",
  },
};
